import React from 'react';

const Chat: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="95"
      height="60"
      viewBox="0 0 95 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M94.6685 47.6807C94.8635 50.4007 92.8186 52.7681 90.096 52.9656L63.7586 54.8756L1.55607 59.3856C0.233574 59.4806 -0.508926 57.9031 0.403574 56.9431L10.3386 46.5356L7.73607 10.6607C7.53857 7.94068 9.58357 5.57318 12.3086 5.37568L86.2561 0.0131821C88.9785 -0.184318 91.3436 1.86068 91.541 4.58568L94.4835 45.1407L94.6685 47.6807Z"
        fill="#42EC9A"
      />
      <path
        d="M24.0361 43.3432C23.8411 43.3432 23.6786 43.1932 23.6636 42.9982C23.6486 42.7907 23.8011 42.6107 24.0086 42.5957L57.8511 39.9982C58.0586 39.9757 58.2386 40.1357 58.2536 40.3432C58.2686 40.5507 58.1161 40.7307 57.9086 40.7457L24.0636 43.3432C24.0536 43.3432 24.0461 43.3432 24.0361 43.3432Z"
        fill="#1D232A"
      />
      <path
        d="M23.3511 31.0129C23.1561 31.0129 22.9936 30.8629 22.9786 30.6679C22.9636 30.4604 23.1161 30.2804 23.3236 30.2654L72.1835 26.5129C72.3885 26.4904 72.571 26.6504 72.586 26.8579C72.601 27.0654 72.4485 27.2454 72.241 27.2604L23.3811 31.0104C23.3711 31.0129 23.3611 31.0129 23.3511 31.0129Z"
        fill="#1D232A"
      />
      <path
        d="M22.2036 19.6781C22.0086 19.6781 21.8461 19.5281 21.8311 19.3331C21.8161 19.1256 21.9686 18.9456 22.1761 18.9306L56.7636 16.2756C56.9686 16.2531 57.1511 16.4131 57.1661 16.6206C57.1811 16.8281 57.0286 17.0081 56.8211 17.0231L22.2311 19.6756C22.2211 19.6781 22.2136 19.6781 22.2036 19.6781Z"
        fill="#1D232A"
      />
      <path
        d="M61.4189 16.6654C61.2239 16.6654 61.0614 16.5154 61.0464 16.3204C61.0314 16.1129 61.1839 15.9329 61.3914 15.9179L79.6739 14.5129C79.8789 14.4904 80.0614 14.6504 80.0764 14.8579C80.0914 15.0654 79.9389 15.2454 79.7314 15.2604L61.4489 16.6654C61.4364 16.6654 61.4289 16.6654 61.4189 16.6654Z"
        fill="#1D232A"
      />
    </svg>
  );
};

export default Chat;
